// internal
import { axios, def, handleError, handleResponse } from './internal';

// state
import { storage } from '@goldblack/client-storage';

function AdminUserDelete(userId, service = 'loise', onSuccess = null) {
    axios
        .post('/api/admin_user_delete', {
            userId,
            service,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    if (onSuccess) onSuccess(userId);
                    storage.transience.setState('internal.success', 'The user account has been deleted.');
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminUserDelete };
